<div style="width: 100%" class="app-date-picker" [ngClass]="cls">
  <mat-form-field class="mydatepicker" floatLabel="always" *ngIf="!readonly">
    <!-- {{ _required ? "*" : "" }}-->
    <mat-label>{{ label }}</mat-label>
    <input matInput #dic [formControl]="ic" (keyup)="filterInputKeyupFrom()" />
    <!--Dummy for date picker-->
    <input
      style="display: none"
      matInput
      [matDatepicker]="dp"
      (dateInput)="onDateChange($event)"
      [formControl]="ic2"
      (dateChange)="onDateChange($event)"
    />
    <mat-hint *ngIf="!_noHint">TT.MM.JJJJ</mat-hint>
    <mat-datepicker-toggle
      *ngIf="!readonly"
      matSuffix
      [for]="dp"
    ></mat-datepicker-toggle>
    <mat-datepicker #dp></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="mydatepicker" floatLabel="always" *ngIf="readonly">
    <!-- {{ _required ? "*" : "" }}-->
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      #dic
      [formControl]="ic"
      [readonly]="readonly"
      (keyup)="filterInputKeyupFrom()"
    />
  </mat-form-field>
</div>
